import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { SpeedbumpLink } from "./SpeedbumpLink";
import { allowList } from "./allowList";

interface Props {
  to: string;
  activeClassName?: string | undefined;
  partiallyActive?: boolean | undefined;
  target?: string;
  className?: string;
}

// Since DOM elements <a> cannot receive activeClassName
// and partiallyActive, destructure the prop here and
// pass it only to GatsbyLink
export const Link: React.FC<Props> = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  ...other
}) => {
  const telRegex = /.*(tel:\d{3}(\.|\-)\d{3}(\.|\-)\d{4})$/;
  const telMatch = to?.match(telRegex);

  if (telMatch && telMatch[1]) {
    return (
      <a {...other} href={telMatch[1]} data-testid="a">
        {children}
      </a>
    );
  }

  // Tailor the following test to your environment.
  // test does not contain 'http' in the to string
  const internal = !/.*http.*/.test(to?.toLowerCase());

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <GatsbyLink
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
        data-testid="link"
      >
        {children}
      </GatsbyLink>
    );
  }

  const hostname = new URL(to).hostname;

  if (allowList.includes(hostname)) {
    return (
      <a href={to} {...other} data-testid="a">
        {children}
      </a>
    );
  }

  return (
    <SpeedbumpLink to={to} {...other}>
      {children}
    </SpeedbumpLink>
  );
};
